import React from 'react'

const BundleTicketBlock = ({ icon, count, countLabel, title, oldCount }) => {
  return (
    <div className="single-bundle-card__ticket-block">
      <div className="single-bundle-card__ticket-icon">{icon}</div>
      <div className="single-bundle-card__ticket-info">
        <p className="single-bundle-card__ticket-value">
          {countLabel || `${count} Tickets`}
          {oldCount && (
            <span className="single-bundle-card__ticket-value-old">
              {oldCount} Tickets
            </span>
          )}
        </p>

        <span className="single-bundle-card__ticket-title">{title}</span>
      </div>
    </div>
  );
};

export default BundleTicketBlock;